import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiGetSalaries = zipCode => {
  return httpClient.get(`gag/salaries/${zipCode}/`).then(data => data)
}

export const apiGetCalculation = sinisterId => {
  return httpClient.get(`gag/manpower/calculation`).then(data => data)
}

export const apiPostCalculation = (sinisterId, price) => {
  return httpClient
    .post(`gag/manpower/calculation`, {
      price,
      sinister_id: sinisterId
    })
    .then(data => data)
}

export const apiGetMaterials = sinisterId => {
  const params = new URLSearchParams()
  params.set('sinister_id', sinisterId)

  return httpClient
    .get(`gag/materials${paramsToString(params)}`)
    .then(data => data)
}
